exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn.forgot-password-button,.btn.forgot-password-button[disabled]{min-width:303px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/ForgotPassword/ForgotPassword.scss
 ** module id = 1198
 ** module chunks = 0
 **/